import React, {Component} from 'react';
import {SubCriterionParameter, VALUETYPE} from "../../domain/criterion/subCriterionParameterDomain";
import {TextField} from "material-ui";
import {SubCriterion} from "../../domain/criterion/subCriterionDomain";
import {observer} from "mobx-react";
import sbToolParamsService from "../../service/paramsService";
import {ProjectVersionParamValue} from "../../domain/project/projectVersionParameterValueDomain";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {observable} from "mobx";
import {loc} from "../../../core/common/config/locales";


interface Props {
  subCriterion: SubCriterion
  handleChangeValueState: (bool:boolean)=>void

}

const PARAM_NUMBER: number = 1

@observer
class ParametersInputsForm extends Component<Props, undefined> {

  readonly errors = observable.map<string>();

  private onInput = (e: React.FormEvent<{}>, subCriterionParam: SubCriterionParameter) => {

    const value = e.target.value;
    this.validate(value, subCriterionParam);
    let versionParam = sbToolParamsService.paramsValues.find(p => p.paramNumber === PARAM_NUMBER && p.parameter.paramId === subCriterionParam.paramId)
    if (versionParam) {
      versionParam.value = value;
    } else {
      let param = new ProjectVersionParamValue({
        value: value,
        paramNumber: PARAM_NUMBER,
        projectVersion: SbToolProjectVersionService.projectVersion,
        parameter: subCriterionParam,
        count : 1,
        $new: true
      })
      param.initAfterRead(true);
      sbToolParamsService.paramsValues.push(param);
    }
    this.props.handleChangeValueState(true)

  }

  private validate = (value: string, subCriterionParam: SubCriterionParameter) => {
    const paramId = String(subCriterionParam.paramId);
    const valueType = subCriterionParam.valueType;

    if (subCriterionParam.optional) {
      return;
    }

    if (!value) {
      this.errors.set(paramId, loc.i18n`Parameter is empty`);
      return;
    }
    if (valueType === VALUETYPE.NUMBER && isNaN(Number(value))) {
      this.errors.set(paramId, loc.i18n`Parameter should be number`);
      return;
    }
    if (valueType === VALUETYPE.PERCENTS && isNaN(Number(value))) {
      this.errors.set(paramId, loc.i18n`Parameter should be number`);
      return;
    }
    if (valueType === VALUETYPE.PERCENTS && Number(value) > 100) {
      this.errors.set(paramId, loc.i18n`Parameter should be 100 or less`);
      return;
    }

    if (valueType === VALUETYPE.PARAM_ID) {
      this.errors.set(paramId, loc.i18n`Param id not supported here`);
      return;
    }
    this.errors.delete(paramId);
  }

  private renderInput = (subCriterionParam: SubCriterionParameter) => {
    let versionParam = sbToolParamsService.paramsValues.find(p => p.paramNumber === PARAM_NUMBER && p.parameter.paramId === subCriterionParam.paramId)
    let value = "";
    if (versionParam) {
      value = versionParam.value;
    }
    return (<TextField
        floatingLabelText={subCriterionParam.name}
        fullWidth={true}
        value={value}
        onChange={e => this.onInput(e, subCriterionParam)}
        errorText={this.errors.get(String(subCriterionParam.paramId))}/>
    )
  }


  render() {
    return (
      <div style={{marginTop: 20, width: "100%"}}>
        {this.props.subCriterion.parameters
          .sort((p1,p2) => p1.number - p2.number)
          .map(p => this.renderInput(p))}
      </div>
    )
  }
}

export default ParametersInputsForm;






// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/parametersInputsForm.tsx